import React from 'react';
import {NodeProps} from 'reactflow';

import {BenchlingIconName} from 'ui-library/icons/BenchlingIcon';
import {BaseSectionedNodeRenderer} from 'ui-library/reactflow/nodes/BaseSectionedNodeRenderer/BaseSectionedNodeRenderer';
import {BaseSectionedNodeData} from 'ui-library/reactflow/nodes/BaseSectionedNodeRenderer/BaseSectionedNodeRendererTypes';
import {DefaultSectionedNodeRendererNodeHandle} from 'ui-library/reactflow/nodes/BaseSectionedNodeRenderer/private-components/DefaultSectionedNodeRendererNodeHandle';

import {TaskSchemaNodeRowRenderer} from './TaskSchemaNodeRowRenderer';

interface TaskSchemaDomainData {
  id: string;
}

export interface TaskSchemaNodeRowData {
  id: string;
  isFlowchartTask: boolean;
  sectionName: string;
  fieldName: string;
  fieldIcon: BenchlingIconName;
}

/** Populated data to be passed to the base node renderer. */
export type TaskSchemaNodeData = TaskSchemaDomainData & BaseSectionedNodeData<TaskSchemaNodeRowData>;

/**
 * Props for the task schema node renderer, omitting fields that we don't want to populate for
 * the base node renderer. Some of these fields are populated within the TaskSchemaNodeRenderer.
 */
export type TaskSchemaNodeRendererProps = NodeProps<
  Omit<
    TaskSchemaNodeData,
    'rowRenderer' | 'nodeHeaderHandleRenderer' | 'nodeIcon' | 'nodeValidationState' | 'nodeSecondaryInfo'
  >
>;

export default function TaskSchemaNodeRenderer(props: TaskSchemaNodeRendererProps): JSX.Element {
  const propsWithRenderers: NodeProps<TaskSchemaNodeData> = {
    ...props,
    data: {
      ...props.data,
      rowRenderer: TaskSchemaNodeRowRenderer,
      nodeHeaderHandleRenderer: DefaultSectionedNodeRendererNodeHandle,
    },
  };
  return <BaseSectionedNodeRenderer<TaskSchemaNodeRowData, TaskSchemaNodeData> {...propsWithRenderers} />;
}
